import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'zh-tw',
    fullName: 'Chinese (Taiwan)',
    nativeName: '中文（台灣）',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "精空",
    landing_title: "令人驚奇的事即將到來",
    landing_subtitle: "ArgVoid 是一家應用程式和遊戲開發工作室。請繼續關注，新內容即將推出！",
    select_language: "選擇語言",
    search_placeholder: "搜尋語言...",
    terms_title: "服務條款",
    policy_title: "隱私權政策",
    cookies_title: "Cookie 政策",
    terms_content: `
        <strong>1。接受條款</strong><br>
        造訪 ArgVoid 即表示您接受這些服務條款。如果不同意這些條款，則不應使用該服務。 <br><br>

        <strong>2。平台使用</strong><br>
        ArgVoid 及其應用程式是「按原樣」提供，用於資訊和創意目的。該服務只能用於合法目的。 <br><br>

        <strong>3。禁止行為</strong><br>
        嚴格禁止利用網站漏洞、發送垃圾郵件或嘗試未經授權存取基礎設施。 <br><br>

        <strong>4。免責聲明</strong><br>
        平台和服務可能隨時修改，恕不另行通知。不提供有關服務的正常運作時間或可用性的保證。
    `,
    policy_content: `
        <strong>1。資訊收集</strong><br>
        該平台目前不需要用戶身份驗證或帳戶創建。不會主動收集訪客的個人識別資訊（例如姓名或電子郵件地址）。 <br><br>

        <strong>2。使用資料</strong><br>
        可以收集基本的匿名分析來了解網站流量並改進應用程式。該數據與個人用戶身分無關。 <br><br>

        <strong>3。第三方服務</strong><br>
        第三方提供者可用於託管和分析服務。這些各自提供者的隱私權慣例管理在其基礎設施上處理的匿名資料。 <br><br>

        <strong>4。資料安全</strong><br>
        實施合理的安全措施來保護平台。然而，沒有一種互聯網傳輸方法是完全安全的。 <br><br>
    `,
    cookies_content: `
        <strong>1。什麼是 Cookie 和本地儲存？ </strong><br>
        Cookie 和瀏覽器本地儲存是儲存在裝置上的小數據文件，用於記住存取期間的配置偏好。 <br><br>

        <strong>2。使用目的</strong><br>
        瀏覽器LocalStorage嚴格用於保存配置設置，如：<br>
        - 語言偏好<br>
        - 使用者介面配置（例如版面配置或主題設定）<br>
        - 臨時應用程式快取<br><br>

        <strong>3。無追蹤</strong><br>
        Cookie 和本地儲存不用於廣告或第三方追蹤目的。所有儲存的資料均嚴格用於平台的核心功能。 <br><br>

        <strong>4。控制</strong><br>
        可以隨時透過瀏覽器設定清除瀏覽器數據，這將重置所有本地配置。
    `,
    cookie_consent_text: "我們使用基本 cookie 來確保網站正常運行，例如保持您的會話處於活動狀態、保存您的語言首選項以及其他自訂配置。",
    read_policy: "閱讀 Cookie 政策",
    support_title: "聯繫支援人員",
    support_subject_label: "主題",
    support_message_label: "訊息",
    support_submit_button: "發送訊息",
    support_hint: "注意：這將打開您的預設電子郵件應用程式來發送訊息。",
    support_success_msg: "打開您的電子郵件應用程式...",
    support_error_msg: "發送訊息失敗。請稍後重試。",
    explorer_title: "探險家",
    history_title: "歷史",
    animation_title: "卡通",
    config_title: "配置",
    tool_mouse: "選擇（Ctrl+M）",
    tool_brush: "畫筆（Ctrl+B）",
    tool_brush_mode: "切換模式（穩定/清晰）",
    tool_eraser: "橡皮擦 (Ctrl+E)",
    tool_brush_size: "調整畫筆大小",
    tool_bucket: "填充 (Ctrl+F)",
    tool_eyedropper: "滴管",
    tool_grid: "網格 (Ctrl+Shift+B)",
    tool_rotate: "旋轉（Ctrl+Shift+R）",
    tool_flip_h: "翻轉 H (Ctrl+Shift+H)",
    tool_flip_v: "翻轉 V (Ctrl+Shift+V)",
    tool_transpose: "轉置 (Ctrl+Shift+T)",
    label_width: "寬度",
    label_height: "高度",
    label_frames: "幀數",
    label_animation: "動畫風格",
    label_background_color: "背景顏色",
    label_interval: "間隔",
    tool_anim_config: "動畫配置",
    label_new_width: "新寬度",
    label_new_height: "新高度",
    label_apply: "申請",
    label_colors: "顏色",
    label_size: "尺寸",
    label_tolerance: "寬容",
    val_horizontal: "水平的",
    val_vertical: "垂直的",
    val_sequence: "順序",
    val_bounce: "彈跳",
    val_random: "隨機的",
    val_solid: "堅硬的",
    val_clear: "清除",
    action_add_sheet: "新表",
    action_import: "進口",
    action_export: "出口",
    action_sort_projects: "種類",
    sort_date_old: "最舊的在前",
    sort_date_new: "最新第一",
    sort_name_az: "姓名（A-Z）",
    sort_name_za: "姓名（Z-A）",
    action_new_sprite: "新雪碧",
    action_new_project: "新專案",
    modal_save_all_title: "儲存所有更改",
    modal_save_all_desc: "選擇要儲存的資產：",
    modal_save_selected: "儲存所選內容",
    action_saved: "已儲存",
    modal_create_sprite_title: "建立新精靈",
    modal_create_project_title: "建立新專案",
    modal_add_sheet_title: "新增工作表",
    modal_rename_sheet_title: "重新命名工作表",
    modal_rename_sprite_title: "重命名精靈",
    modal_delete_sprite_title: "刪除精靈",
    modal_delete_project_title: "刪除項目",
    modal_delete_sheet_title: "刪除工作表",
    placeholder_sprite_name: "姓名",
    placeholder_project_name: "姓名",
    placeholder_sheet_name: "姓名",
    placeholder_new_name: "新名稱",
    action_create: "創造",
    action_add: "添加",
    action_rename: "重新命名",
    action_duplicate: "複製",
    action_delete: "刪除",
    action_cancel: "取消",
    confirm_delete_sprite: "您確定要刪除這個精靈嗎？",
    confirm_delete_project: "您確定要刪除該項目嗎？所有精靈都將被刪除。",
    confirm_delete_sheet: "您確定要刪除此工作表嗎？",
    err_select_sprite: "請先選擇一個精靈。",
    err_select_project: "請先選擇一個項目。",
    err_name_empty: "名稱不能為空。",
    err_sprite_exists: "具有該名稱的精靈已存在。",
    err_project_exists: "具有該名稱的項目已存在。",
    err_no_content: "沒有要儲存的內容。",
    err_no_changes: "沒有要儲存的變更。",
    err_delete_last_sheet: "無法刪除最後一張紙。",
    err_extract_frames: "無法提取任何幀。",
    err_indexeddb: "本地保存失敗。您的瀏覽器可能不支援 IndexedDB。",
    msg_upload_success: "上傳成功：{0}",
    msg_upload_failed: "上傳失敗：{0}",
    msg_save_success: "保存成功。",
    msg_saving: "儲存...",
    msg_multi_save_result: "已儲存 {0} 個資源。 {1} 失敗。",
    menu_title: "選單",
    menu_save: "節省",
    menu_save_all: "全部保存",
    menu_support: "聯繫支援人員",
    label_local_storage: "本地儲存",
    label_sign_in: "登入",
    modal_export_title: "導出精靈",
    label_filename: "檔案名稱",
    label_format: "格式",
    action_export_confirm: "出口",
};

export default translations;
